import { z } from 'zod';

const assignmentSchema = z.object({
  firstActivation: z.string().nullable(),
  lastActivity: z.string().nullable(),
  onboardEmailSent: z.string().nullable(),
  productName: z.string().min(1),
});

const assignmentsSchema = z.array(assignmentSchema);

export const assetSchema = z.object({
  assignments: assignmentsSchema,
  email: z.string().nullable(),
  externalId: z.string().min(1),
  firstName: z.string().nullable(),
  id: z.number().min(1),
  lastName: z.string().nullable(),
  phoneNumber: z.string().nullable(),
});

export const assetsSchema = z.array(assetSchema);

export const paginatedAssetsSchema = z.object({
  data: assetsSchema,
  size: z.number(),
});

export type Asset = z.infer<typeof assetSchema>;

export type Assets = z.infer<typeof assetsSchema>;

export type PaginatedAssets = z.infer<typeof paginatedAssetsSchema>;
